import { render, staticRenderFns } from "./AiChatbotStarter.vue?vue&type=template&id=36c5ba12&scoped=true"
import script from "./AiChatbotStarter.vue?vue&type=script&lang=ts"
export * from "./AiChatbotStarter.vue?vue&type=script&lang=ts"
import style0 from "./AiChatbotStarter.vue?vue&type=style&index=0&id=36c5ba12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c5ba12",
  null
  
)

export default component.exports